import * as angular from "angular";
import {IController} from "angular";

export class BillingAccountIndicator implements IController {

  billingAccountId: any;

  private billingAccount;

  /* @ngInject */
  constructor(private $billingAccounts) {
  }

  $onInit() {
    if (this.billingAccountId) {
      this.$billingAccounts(this.billingAccountId).$asyncValue()
        .then((billingAccount) => {
          this.billingAccount = billingAccount;
        })
    }
  }

  $onChanges(changes) {
    if (changes.billingAccountId && !changes.billingAccountId.isFirstChange()) {
      this.billingAccount = undefined;

      if (this.billingAccountId) {
        this.$onInit();
      }
    }
  }
}

angular
  .module('bringoz.admin.billing-accounts')
  .component('billingAccountIndicator', {
    bindings: {
      billingAccountId: '<'
    },
    template: require('./billing-account-indicator.html').default,
    controller: BillingAccountIndicator
  });
